import { render, staticRenderFns } from "./StatisticalValuesPanel.vue?vue&type=template&id=04369165&scoped=true&"
import script from "./StatisticalValuesPanel.vue?vue&type=script&lang=js&"
export * from "./StatisticalValuesPanel.vue?vue&type=script&lang=js&"
import style0 from "./StatisticalValuesPanel.vue?vue&type=style&index=0&id=04369165&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04369165",
  null
  
)

export default component.exports